import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { PlanObraSocial } from '../models/planObraSocial';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/PlanesObrasSociales';

@Injectable({
  providedIn: 'root'
})
export class PlanesObrasSocialesService {
   
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getById(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/Index?id=' + code })
  }

  save(entidad: PlanObraSocial[])
  {
    return this._http.post({ url: baseUrl + '/Save', body: entidad });
  }

  delete(id: number)
  {
    return this._http.get({ url: baseUrl + '/Delete?id=' + id});
  }

  getList(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }

  getByObrasocial(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetByObraSocial?obraSocial=' + code })
  }
}
